// extracted by mini-css-extract-plugin
export default {"mainDiv":"cards_mainDiv__-2M64","textDiv":"cards_textDiv__n9YCH"};